document.addEventListener("DOMContentLoaded", function() {

  const trigger = document.getElementById("fif-discount-popup");
  const popup = document.getElementById("fif-main-popup");
  const closeBtn = document.querySelector(".close-popup");
  const noThanks = document.querySelectorAll(".no-thanks-btn");

  const step1 = document.getElementById("step1");
  const step2 = document.getElementById("step2");
  const stepButtons = document.querySelectorAll(".step-btn");

  const formContainer = document.getElementById("klaviyo-dynamic-form");

  /* OPEN POPUP */
  if (trigger && popup) {
    trigger.addEventListener("click", () => {
      popup.style.display = "flex";
    });
  }

  /* SWITCH TO STEP 2 + LOAD DYNAMIC FORM */
  if (step1 && step2) {
    stepButtons.forEach(btn => {
      btn.addEventListener("click", () => {

        let interest = btn.dataset.interest;
        let formCode = "";

        // Assign Klaviyo forms based on selection
        if (interest === "birds") formCode = '<div class="klaviyo-form-V6rUCE"></div>';
        if (interest === "wildlife") formCode = '<div class="klaviyo-form-VcJb7E"></div>';
        if (interest === "seas") formCode = '<div class="klaviyo-form-RMnaNV"></div>';
        if (interest === "trees") formCode = '<div class="klaviyo-form-RUfFkh"></div>';

        // Insert correct form inside Step 2
        formContainer.innerHTML = formCode;

        // Move to step 2
        step1.style.display = "none";
        step2.style.display = "block";
      });
    });
  }

  /* CLOSE POPUP */
  if (closeBtn) {
    closeBtn.addEventListener("click", () => popup.style.display = "none");
  }

  noThanks.forEach(btn => {
    btn.addEventListener("click", () => popup.style.display = "none");
  });

  /* CLOSE ON OUTSIDE CLICK */
  popup?.addEventListener("click", (e) => {
    if (e.target === popup) popup.style.display = "none";
  });


  /* ------------------------------ */
  /*   KLAVIYO DUPLICATE HANDLER    */
  /* ------------------------------ */
  document.addEventListener("klaviyoForms.error", function(e) {
    const msg = e.detail.message || "";

    // Detect duplicate email
    if (msg.toLowerCase().includes("already")) {
      
      alert("You are already registered!");

      // Close popup after message
      if (popup) popup.style.display = "none";
    }
  });

});



// Product page change style popup
document.addEventListener("DOMContentLoaded", function () {

  const changeBtn = document.getElementById("cs-change-style-btn");
  const stylePopup = document.getElementById("cs-style-popup");
  const styleClose = document.querySelector(".cs-style-close");

  if (changeBtn && stylePopup) {
    changeBtn.addEventListener("click", function () {
      stylePopup.style.display = "flex";
    });
  }

  if (styleClose && stylePopup) {
    styleClose.addEventListener("click", function () {
      stylePopup.style.display = "none";
    });
  }

  if (stylePopup) {
    stylePopup.addEventListener("click", function (e) {
      if (e.target === this) {
        this.style.display = "none";
      }
    });
  }

  document.querySelectorAll(".cs-style-item").forEach(item => {
    item.addEventListener("click", function () {
      let handle = this.getAttribute("data-handle");
      window.location.href = "/products/" + handle;
    });
  });

});


// close discount badge
document.addEventListener("DOMContentLoaded", function() {

  const trigger = document.getElementById("fif-discount-popup");
  const closeDiscount = document.querySelector(".fif-discount-close");

  if (closeDiscount && trigger) {
    closeDiscount.addEventListener("click", (e) => {
      e.stopPropagation();
      trigger.style.display = "none";
    });
  }

});


// hide blank div
document.addEventListener('DOMContentLoaded', function() {
    const dynamicBox = document.getElementById('cs-style-dynamic-box');
    const selectedStyleBox = document.querySelector('.cs-selected-style-box');
    
    if (!dynamicBox || !selectedStyleBox) return; // prevent error

    function checkDynamicBox() {
        if (dynamicBox.innerHTML.trim() === '') {
            selectedStyleBox.classList.add('cs-box-hidden');
        } else {
            selectedStyleBox.classList.remove('cs-box-hidden');
        }
    }
    
    checkDynamicBox();
    
    const observer = new MutationObserver(checkDynamicBox);
    observer.observe(dynamicBox, { childList: true, subtree: true });
});


// Today's date
document.addEventListener("DOMContentLoaded", function () {
    const today = new Date();
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    const lastDayNextMonth = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0);

    lastDayNextMonth.setHours(23, 59, 0);

    function formatDate(date) {
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
    }

    const finalOutput = `${formatDate(lastDayNextMonth)} at 11:59 PM`;

    document.querySelectorAll('#futureDate').forEach(el => {
        el.textContent = finalOutput;
    });
});



document.addEventListener("DOMContentLoaded", function () {

  const customizationBtn = document.querySelector('.customization-btn');
  const quantityBlock = document.querySelector('.product-block.quantityBlock');
  const buttonsBlocks = document.querySelectorAll('.add-to-cart');

  if (!quantityBlock) return;

  // Save original position (if button exists)
  let originalParent = null;
  let originalNextSibling = null;

  if (customizationBtn) {
    originalParent = customizationBtn.parentNode;
    originalNextSibling = customizationBtn.nextElementSibling;
  }

  function handleCustomizationUI() {

    const checkedRadio = document.querySelector('input[name="Customization"]:checked');
    const isCustom = checkedRadio && checkedRadio.value === "Yes";

    // 1️⃣ Hide / Show Buttons Block
    buttonsBlocks.forEach(function(block) {
      if (isCustom) {
        block.classList.add("hidden");
      } else {
        block.classList.remove("hidden");
      }
    });

    // 2️⃣ Move Customization Button
    if (customizationBtn) {
      if (isCustom) {
        quantityBlock.insertAdjacentElement('afterend', customizationBtn);
      } else {
        if (originalNextSibling) {
          originalParent.insertBefore(customizationBtn, originalNextSibling);
        } else {
          originalParent.appendChild(customizationBtn);
        }
      }
    }

  }

  // Listen for radio change
  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "Customization") {
      handleCustomizationUI();
    }
  });

  // Run once on page load
  handleCustomizationUI();

});
